var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageInfo32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconInfo32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-Icons/pictograms/picto-ui-info-32-Copy",
    fill: "#0063FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.836556,0 32,7.163444 32,16 C31.9899231,24.8323786 24.8323786,31.9899231 16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 Z M16,2.28571429 C8.42580915,2.28571429 2.28571429,8.42580915 2.28571429,16 C2.28571429,23.5741909 8.42580915,29.7142857 16,29.7142857 C23.5741909,29.7142857 29.7142857,23.5741909 29.7142857,16 C29.7060973,8.42920348 23.5707965,2.29390268 16,2.28571429 Z M16.0274286,11.776 C17.0971429,11.776 17.9748571,12.6537143 17.9748571,13.6685714 L17.9748571,13.6685714 L17.9748571,24.5302857 C17.9748571,25.5725714 17.0971429,26.4228571 16.0274286,26.4228571 C14.9302857,26.4228571 14.08,25.5725714 14.08,24.5302857 L14.08,24.5302857 L14.08,13.6685714 C14.08,12.6537143 14.9302857,11.776 16.0274286,11.776 Z M16.0274286,6.09828571 C17.3165714,6.09828571 18.3314286,7.08571429 18.3314286,8.34742857 C18.3314286,9.60914286 17.3165714,10.6514286 16.0274286,10.6514286 C14.7108571,10.6514286 13.6685714,9.60914286 13.6685714,8.34742857 C13.6685714,7.08571429 14.7108571,6.09828571 16.0274286,6.09828571 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageInfo32);
export default __webpack_public_path__ + "static/media/messageInfo32.3b2525677ce7b275c9508e8231d8b34f.svg";
export { ForwardRef as ReactComponent };